// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {AlliancesLandingModuleLayout} from 'app_components/modules/admin/landings/alliancesLanding'
import { ILanding } from 'app_types/admin/landings/landingTypes'
import LandingService from 'app_services/admin/landings/landingService'
import PermissionService from 'app_services/secure/permission/permissionService'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IAlliancesLandingModuleProps {}
interface IAlliancesLandingModuleState {
  landingInfo: ILanding | null
  status: null | 'loading' | 'error'
  loadingForm: null | 'loading'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class AlliancesLandingModule extends Component<IAlliancesLandingModuleProps, IAlliancesLandingModuleState> {

  public moduleName: string = 'module:landings'
  private landingService: LandingService
  private permission: PermissionService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IAlliancesLandingModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      landingInfo: null,
      loadingForm: null
    }
    this.landingService = new LandingService()
    this.permission = new PermissionService(this.moduleName)
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.fetchLandingData()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  fetchLandingData = async () => {
    this.setState({ status: 'loading' })

    let httpParams: any = {
      slug: 'alliances'
    }

    let landing: ILanding | null = null

    const landingResponse = await this.landingService.fetchLandingData(httpParams)

    if (landingResponse) {
      landing = landingResponse
    }

    this.setState({
      landingInfo: landing,
      status: null
    })
  }

  onHandleSaved = (data: any) => {
    if (data.status === 'success') {
      this.fetchLandingData()
    }
  }

  render() {
    return(
      <AlliancesLandingModuleLayout
        {...this.props}
        onHandleSaved={this.onHandleSaved}
        landingInfo={this.state.landingInfo}
        loadingForm={this.state.loadingForm}
        permission={this.permission}
      />
    )
  }
}

export default connect(mapStatesToProps)(AlliancesLandingModule)
